import React, {useEffect, useState} from "react";
import Api from '../../interface/api/visit/in-out';

export default function VisitorInoutComponent(props) {
    const {location, match} = props;

    useEffect(() => {
        let win = window.open(`${location.pathname}/view`, '_self');
        // window.open('', '_self', '');
        // window.close();
        // localStorage.setItem('item', JSON.stringify(win));
    }, [match.params.visitorInfoSeq])

    return (
            <div className="admin nv_wrap info_wrap"></div>
    )
}